export const apiBaseUrl = `${(import.meta.env.VITE_BACKEND_URL ?? '').replace(/\/+$/u, '')}/api`;
